module.exports = "<a [routerLink]=\"config.router\" [ngClass]=\"config.style\">\n  {{ config.label }}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-link/form-link.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-link/form-link.component.html
// module chunks = main